import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import AgentSvg from "../../assets/navbar/Agentes_on_light_blue.svg";
import desmaskIfNumber from "../../utils/desmaskIfNumber";
import api from "../../services/api";
import agent from "../../services/agents";
import person from "../../services/person";

import { Formik, Form, Field } from "formik";

import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";
import AutoCompleteSearch from "../../components/AutoCompleteSearch";

import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import firstSchema from "./validations/schemaValidation";
import history from "../../utils/history";

import SkeletonRadioInput from "../../components/SkeletonRadioInput";
import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";
import PoPup from "../../components/PopUp";
import { type } from "os";
import TextArea from "../../components/TextArea";
import ListLog from "../../components/ListLog";

import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../../components/Button-v2";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";

export default function AgentsRegistration() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [formData, setFormData] = useState();
  const [regionalId, setRegionalId] = useState(null);
  const [convenioId, setConvenioId] = useState(null);
  const [initialState, setInitialState] = useState({
    id: null,
    pessoaId: null,
    cpfCnpj: "",
    nome: "",
    nomeFantasia: "",
    municipio: "",
    uf: "",
    nomeAgente: "",
    codigoIntegracaoFinanceira: "",
    possuiRegional: "NAO",
    regional: "",
    nomeRegional: "",
    convenio: "",
    nomeConvenio: "",
    status: true,
    observacao: "",
  });
  const [editingPerson, setEditingPerson] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupActivateOpen, setPopupActivateOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({
    id: null,
    cpf: null,
    status: null,
  });
  const globalContext = useContext(Context);

  async function onBlurCnpj(cnpj) {
    let typePerson = "PESSOA_FISICA";
    if (cnpj.length === 14) {
      typePerson = "PESSOA_JURIDICA";
    }
    globalContext.setIsLoading(false);

    try {
      const response = await api.get(
        `api/pessoa/buscar?cpfCnpjOuNome=${cnpj}&tipoPessoa=${typePerson}`
      );
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        const enderecos = content?.[0]?.enderecos;
        let municipio =
          content?.[0]?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
        let uf =
          content?.[0]?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
        if (enderecos && enderecos.length > 1) {
          municipio =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.descricao?.toUpperCase();
          uf =
            content?.[0]?.enderecos?.[
              enderecos?.length - 1
            ]?.municipio?.estado?.nome?.toUpperCase();
        }

        setInitialState({
          ...initialState,
          cpfCnpj: content?.[0]?.cpfCnpj,
          pessoaId: content?.[0]?.id,
          nome: content?.[0]?.nome,
          nomeFantasia: content?.[0]?.nomeFantasia,
          municipio: municipio,
          uf: uf,
        });
      } else if (!response) {
        setInitialState({
          ...initialState,
          pessoaId: null,
          nome: "",
          nomeFantasia: "",
          municipio: "",
          uf: "",
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      setInitialState({
        ...initialState,
        pessoaId: null,
        nome: "",
        nomeFantasia: "",
        municipio: "",
        uf: "",
      });
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function onBlurCnpjRegional(cnpj) {
    if (cnpj.length !== 14) {
      return;
    }
    globalContext.setIsLoading(true);

    try {
      const response = await api.get(`api/regional/buscar/cpfCnpj/${cnpj}`);
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        if (content?.[0]) {
          setRegionalId(content?.[0]?.id);
          setInitialState({
            ...initialState,
            regional: cnpj,
            nomeRegional: content?.[0].nomeRegional,
          });
        }
      } else if (!response) {
        setRegionalId(null);
        setInitialState({
          ...initialState,
          regional: cnpj,
          nomeregional: "",
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      setRegionalId(null);
      setInitialState({
        ...initialState,
        regional: cnpj,
        nomeregional: "",
      });

      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function onBlurCpfConvenio(cpfCnpj) {
    if (cpfCnpj.length !== 14) {
      return;
    }
    globalContext.setIsLoading(true);

    try {
      const response = await api.get(`api/convenio/buscar/Cnpj/${cpfCnpj}`);
      if (
        response?.data &&
        (response.status === 201 || response.status === 200)
      ) {
        const content = response?.data?.content;
        if (content?.[0]) {
          setConvenioId(content?.[0]?.id);
          setRegionalId(null);
          setInitialState({
            ...initialState,
            regional: "",
            nomeregional: "",
            convenio: cpfCnpj,
            nomeConvenio: content?.[0].nomeConvenio,
          });
        }
      } else if (!response) {
        setConvenioId(null);
        setInitialState({
          ...initialState,
          convenio: cpfCnpj,
          nomeConvenio: "",
        });
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } catch (err) {
      setConvenioId(null);
      setInitialState({
        ...initialState,
        convenio: cpfCnpj,
        nomeConvenio: "",
      });
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(
          "Erro ao buscar os dados deste cnpj, tente novamente mais tarde!"
        );
      }
    } finally {
      globalContext.setIsLoading(false);
    }
  }

  async function getDataByUserId() {
    globalContext.setIsLoading(true);
    await agent
      .listData(id)
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          const enderecos = data?.pessoa?.enderecos;
          let municipio =
            data?.pessoa?.enderecos?.[0]?.municipio?.descricao?.toUpperCase();
          let uf =
            data?.pessoa?.enderecos?.[0]?.municipio?.estado?.nome?.toUpperCase();
          if (enderecos && enderecos.length > 0) {
            municipio =
              data?.pessoa?.enderecos?.[
                enderecos?.length - 1
              ]?.municipio?.descricao?.toUpperCase();
            uf =
              data?.pessoa?.enderecos?.[
                enderecos?.length - 1
              ]?.municipio?.estado?.nome?.toUpperCase();
          }

          const cpfCnpj = data?.pessoa?.cpfCnpj;
          const _id = data?.id;
          const pessoaId = data?.pessoa?.id;
          const nome = data?.pessoa?.nome;
          const nomeFantasia = data?.pessoa?.nomeFantasia;
          const codigoIntegracaoFinanceira = data?.codIntegracaoFin;
          const nomeAgente = data?.nomeAgente;
          const regional = data?.regional?.pessoa?.cpfCnpj;
          const nomeregional = data?.regional?.nomeRegional;
          const convenio = data?.convenio?.pessoa?.cpfCnpj;
          const nomeConvenio = data?.convenio?.nomeConvenio;

          setInitialState({
            ...data,
            cpfCnpj: cpfCnpj,
            id: _id,
            pessoaId: pessoaId,
            nome: nome,
            nomeFantasia: nomeFantasia,
            municipio: municipio,
            uf: uf,
            observacao: data?.observacao,
            nomeAgente: nomeAgente,
            codigoIntegracaoFinanceira: codigoIntegracaoFinanceira,
            regional: regional || "",
            nomeRegional: nomeregional || "",
            convenio:
              Object.keys(data?.regional || {}).length === 0 ? convenio : "",
            nomeConvenio:
              Object.keys(data?.regional || {}).length === 0
                ? nomeConvenio
                : "",
            possuiRegional:
              Object.keys(data?.regional || {}).length === 0 ? "NAO" : "SIM",
          });
          setRegionalId(data?.regional?.id || null);
          setConvenioId(
            Object.keys(data?.regional || {}).length === 0
              ? data?.convenio?.id
              : null
          );
        }
      })
      .catch(async (err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar os dados, tente novamente mais tarde!");
        }
      })
      .finally(() => {
        globalContext.setIsLoading(false);
      });
  }

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }

    id !== undefined && setEditingPerson(true);
  }, [id]);

  const sendData = async (dataForm) => {
    if (!dataForm.pessoaId || dataForm.pessoaId === null) {
      toast.error("Digite um cnpj válido.");
      return;
    }
    globalContext.setIsLoading(true);

    const dataSending = {
      id: dataForm?.id,
      nomeAgente: dataForm?.nomeAgente,
      codIntegracaoFin: dataForm?.codigoIntegracaoFinanceira,
      regional:
        dataForm?.possuiRegional === "SIM"
          ? regionalId !== null
            ? {
                id: regionalId,
              }
            : null
          : null,
      convenio:
        dataForm?.possuiRegional === "NAO"
          ? regionalId === null
            ? {
                id: convenioId,
              }
            : null
          : null,
      pessoa: {
        id: dataForm?.pessoaId,
      },
      status: true,
      observacao: dataForm?.observacao,
    };

    const handleEditing = async () => {
      try {
        const response = await agent.editingData(dataForm?.id, dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          getDataByUserId();
          toast.success("Dados atualizados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    const handleCreate = async () => {
      try {
        const response = await agent.sendData(dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          const data = response?.data;
          if (data !== null && data !== undefined) {
            if (data?.pessoa?.id !== null) {
              history?.push(`/cadastro-agentes/${data?.pessoa?.id}`);
            }
          }

          toast.success("Dados cadastrados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    if (id) {
      handleEditing();
    } else {
      handleCreate();
    }
  };

  const handleSubmit = () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };
  const selectAutocomplete = async (item, type) => {
    console.debug("Item/type", item, type);
    if (type === "REGIONAL") {
      setRegionalId(item?.id);
      setInitialState({
        ...initialState,
        regional: item?.cpfCnpj || "",
        nomeRegional: item?.nome || "",
        convenio: "",
        nomeConvenio: "",
      });
    } else if (type === "CONVENIO") {
      setRegionalId(null);
      setConvenioId(item?.id);
      setInitialState({
        ...initialState,
        regional: "",
        nomeRegional: "",
        convenio: item?.cpfCnpj || "",
        nomeConvenio: item?.nome || "",
      });
    }
  };

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  return (
    <>
      <Navbar className="navbar" />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={AgentSvg} />
            <div>
              <S.Title>Agentes</S.Title>
              <S.Description>Cadastro geral de agentes</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={firstSchema}
            onSubmit={(values) => handleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="50%"
                        label="CPF/CNPJ*:"
                        maskChar=""
                        currentType="cpf/cnpj"
                        currency="false"
                        disabled={id}
                        error={errors.cpfCnpj && touched.cpfCnpj}
                        onBlur={(e) => {
                          onBlurCnpj(desmaskIfNumber(e.target.value));
                          setFieldValue("cpfCnpj", e.target.value);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <p>{errors.cpfCnpj}</p>
                <S.InputBox>
                  <Field
                    name="nome"
                    id="nome"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Nome/ Razão Social*:"
                          currency="false"
                          error={errors.nome && touched.nome}
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeFantasia"
                    id="nomeFantasia"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Nome fantasia*:"
                          currency="false"
                          error={errors.nomeFantasia && touched.nomeFantasia}
                          disabled
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="municipio"
                    id="municipio"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Cidade:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="uf"
                    id="uf"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Estado:"
                          {...field}
                          disabled
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
                <S.InputBox>
                  <Field
                    name="nomeAgente"
                    id="nomeAgente"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled={id && initialState.status === false}
                          label="Nome da agente:"
                          type="text"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              nomeAgente: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="codigoIntegracaoFinanceira"
                    id="codigoIntegracaoFinanceira"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          disabled="true"
                          label="Código de Integração Financeira:"
                          currency="false"
                          onChange={(e) => {
                            setInitialState({
                              ...initialState,
                              codigoIntegracaoFinanceira: e.target.value,
                            });
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.TextAreaBox>
                  <Field
                    name="observacao"
                    id="observacao"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <TextArea
                          {...field}
                          type="text"
                          label="Observação:"
                          onChange={(e) => {
                            setFieldValue("observacao", e.target.value);
                          }}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.TextAreaBox>

                <S.InputRadioBox>
                  <Field
                    name="possuiRegional"
                    id="possuiRegional"
                    render={({ field }) => (
                      <S.InputRadio>
                        {!globalContext.isLoading ? (
                          <p>Este agente possuí um regional?</p>
                        ) : (
                          <Skeleton type="radioParagraph" />
                        )}

                        <label>
                          {!globalContext.isLoading ? (
                            <>
                              <input
                                type="radio"
                                name="possuiRegional"
                                className="radio"
                                value="true"
                                disabled={id && initialState.status === false}
                                checked={values.possuiRegional === "SIM"}
                                onChange={() => {
                                  setInitialState({
                                    ...initialState,
                                    possuiRegional: "SIM",
                                  });
                                  setFieldValue("possuiRegional", "SIM");
                                }}
                              />
                              Sim
                            </>
                          ) : (
                            <SkeletonRadioInput />
                          )}
                        </label>
                        <label>
                          {!globalContext.isLoading ? (
                            <>
                              <input
                                type="radio"
                                name="possuiRegional"
                                className="radio"
                                value="false"
                                disabled={id && initialState.status === false}
                                checked={values.possuiRegional === "NAO"}
                                onChange={() => {
                                  setInitialState({
                                    ...initialState,
                                    possuiRegional: "NAO",
                                  });
                                  setFieldValue("possuiRegional", "NAO");
                                }}
                              />
                              Não
                            </>
                          ) : (
                            <SkeletonRadioInput />
                          )}
                        </label>
                      </S.InputRadio>
                    )}
                  ></Field>
                </S.InputRadioBox>
                {values?.possuiRegional === "SIM" ? (
                  <>
                    {!globalContext.isLoading ? (
                      <AutoCompleteSearch
                        label="Digite um novo CPF/CNPJ/Nome de regional para buscar..."
                        handleSearch={selectAutocomplete}
                        updated={values?.possuiRegional}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )}

                    <S.InputBox>
                      <Field
                        name="regional"
                        id="regional"
                        render={({ field }) =>
                          !globalContext.isLoading ? (
                            <InputText
                              {...field}
                              maskChar=""
                              mask="99.999.999/9999-99"
                              label="Regional:"
                              currency="false"
                              disabled
                              error={errors.regional && touched.regional}
                            />
                          ) : (
                            <Skeleton type="input" />
                          )
                        }
                      />
                    </S.InputBox>

                    <S.InputBox>
                      <Field
                        name="nomeRegional"
                        id="nomeRegional"
                        render={({ field }) =>
                          !globalContext.isLoading ? (
                            <InputText
                              {...field}
                              label="Nome do regional:"
                              currency="false"
                              disabled
                              error={
                                errors.nomeRegional && touched.nomeRegional
                              }
                            />
                          ) : (
                            <Skeleton type="input" />
                          )
                        }
                      />
                    </S.InputBox>
                  </>
                ) : (
                  <>
                    {!globalContext.isLoading ? (
                      <AutoCompleteSearch
                        label="Digite um novo CPF/CNPJ/Nome de convênio para buscar..."
                        handleSearch={selectAutocomplete}
                        updated={values?.possuiRegional}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )}
                    <S.InputBox>
                      <Field
                        name="convenio"
                        id="convenio"
                        render={({ field }) =>
                          !globalContext.isLoading ? (
                            <InputText
                              {...field}
                              maskChar=""
                              mask="99.999.999/9999-99"
                              label="Convenio:"
                              currency="false"
                              disabled
                              error={errors.convenio && touched.convenio}
                            />
                          ) : (
                            <Skeleton type="input" />
                          )
                        }
                      />
                    </S.InputBox>

                    <S.InputBox>
                      <Field
                        name="nomeConvenio"
                        id="nomeConvenio"
                        render={({ field }) =>
                          !globalContext.isLoading ? (
                            <InputText
                              {...field}
                              label="Nome do convenio:"
                              currency="false"
                              disabled
                              error={
                                errors.nomeConvenio && touched.nomeConvenio
                              }
                            />
                          ) : (
                            <Skeleton type="input" />
                          )
                        }
                      />
                    </S.InputBox>
                  </>
                )}
              </Form>
            )}
          </Formik>
          <S.ButtonContainer>
            <S.ButtonExclude>
              {id && initialState.status === true ? (
                <Button
                  button="primary"
                  className="inativar"
                  onClick={() => {
                    setPopupOpen(true);
                    setUserSelected({
                      id: initialState.id,
                      cpf: initialState.cpfCnpj,
                    });
                  }}
                >
                  Inativar cadastro
                </Button>
              ) : initialState.status ? (
                <></>
              ) : (
                <Button button="primary" className="inativo">
                  Cadastro inativo
                </Button>
              )}
            </S.ButtonExclude>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            {id && initialState.status === false ? (
              <Button
                button="primary"
                onClick={() => {
                  setPopupActivateOpen(true);
                }}
              >
                Ativar cadastro
              </Button>
            ) : (
              <Button button="primary" onClick={() => handleSubmit()}>
                Salvar cadastro
              </Button>
            )}
          </S.ButtonContainer>
        </S.Content>
        <S.Content>
          {initialState?.id && (
            <ListLog entidadeId={initialState.id} nomeEntidade="Agente" />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Content>
      </S.Wrapper>
      {popupOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupOpen}
          userSelected={userSelected}
          updateList={getDataByUserId}
          endPoint="/api/agente/"
          useMask="##.###.###/####-##"
          inativar={true}
          ativar={false}
          showCpfCnpj={false}
          textExclude={
            "Você deseja realmente inativar este cadastro e também os usuários vinculados a ele?"
          }
          messageFailed={"Error ao inativar o agente com o CNPJ"}
          messageSuccess={"Sucesso ao inativar o agente"}
        />
      )}
      {popupActivateOpen && (
        <PoPup
          setIsLoading={globalContext.setIsLoading}
          setOpenPopup={setPopupActivateOpen}
          userSelected={initialState}
          updateList={getDataByUserId}
          endPoint="/api/agente/"
          inativar={false}
          ativar={true}
          showCpfCnpj={false}
          textExclude={"Você deseja realmente ativar este cadastro?"}
          messageFailed={"Error ao ativar a agente com o CNPJ"}
          messageSuccess={"Sucesso ao ativar a agente"}
        />
      )}
    </>
  );
}
